export const MESSENGER_CONVERSATION_LIST_SET_MODE = 'MESSENGER_CONVERSATION_LIST_SET_MODE';
export const MESSENGER_SET_VIEW_MODE = 'MESSENGER_SET_VIEW_MODE';
export const MESSENGER_TOGGLE_DISPLAY_CONTACT_DETAILS = 'MESSENGER_TOGGLE_DISPLAY_CONTACT_DETAILS';
export const MESSENGER_TOGGLE_NEW_MESSAGE_ITEM = 'MESSENGER_TOGGLE_NEW_MESSAGE_ITEM';
export const MESSENGER_SELECT_CONVERSATION_LIST_ACTIVE_ITEM =
  'MESSENGER_SELECT_CONVERSATION_LIST_ACTIVE_ITEM';
export const MESSENGER_SELECT_CONVERSATION_RECIPIENTS_LIST =
  'MESSENGER_SELECT_CONVERSATION_RECIPIENTS_LIST';
export const MESSENGER_REMOVE_SELECTED_RECIPIENT = 'MESSENGER_REMOVE_SELECTED_RECIPIENT';
export const MESSENGER_ADD_NEW_RECIPIENT = 'MESSENGER_ADD_NEW_RECIPIENT';
export const MESSENGER_REMOVE_NEW_RECIPIENT = 'MESSENGER_REMOVE_NEW_RECIPIENT';
export const MESSENGER_UPDATE_SEARCH_QUERY = 'MESSENGER_UPDATE_SEARCH_QUERY';
export const MESSENGER_MARK_CONVERSATION_AS_READ = 'MESSENGER_MARK_CONVERSATION_AS_READ';
export const MESSENGER_ADD_CONVERSATION_TO_SELECTED = 'MESSENGER_ADD_CONVERSATION_TO_SELECTED';
export const MESSENGER_REMOVE_CONVERSATION_FROM_SELECTED =
  'MESSENGER_REMOVE_CONVERSATION_FROM_SELECTED';
export const MESSENGER_CLEAR_ACTIVE_ITEM = 'MESSENGER_CLEAR_ACTIVE_ITEM';
export const MESSENGER_CLEAR_SELECTED_CONVERSATIONS = 'MESSENGER_CLEAR_SELECTED_CONVERSATIONS';
export const MESSENGER_SET_CONVERSATIONS_FETCHING_FLAG =
  'MESSENGER_SET_CONVERSATIONS_FETCHING_FLAG';
export const MESSENGER_SET_HAS_NEXT_PAGE_FLAG = 'MESSENGER_SET_HAS_NEXT_PAGE_FLAG';
export const MESSENGER_SET_CONVERSATION_FETCHING_FLAG = 'MESSENGER_SET_CONVERSATION_FETCHING_FLAG';
export const MESSENGER_SET_THREAD_ACTIVE_IDENTIFIERS = 'MESSENGER_SET_THREAD_ACTIVE_IDENTIFIERS';
export const MESSENGER_SET_SENDING_MESSAGE_FLAG = 'MESSENGER_SET_SENDING_MESSAGE_FLAG';
export const MESSENGER_SET_NEW_SENDING_MESSAGE_FLAG = 'MESSENGER_SET_NEW_SENDING_MESSAGE_FLAG';
export const MESSENGER_ADD_CONTACT_TO_RECIPIENT_LIST = 'MESSENGER_ADD_CONTACT_TO_RECIPIENT_LIST';
export const MESSENGER_CLEAR_RECIPIENT_LIST = 'MESSENGER_CLEAR_RECIPIENT_LIST';
export const MESSENGER_SET_CONTACTS_TO_UPDATE_PHONE_NUMBERS =
  'MESSENGER_SET_CONTACTS_TO_UPDATE_PHONE_NUMBERS';
export const MESSENGER_REMOVE_CONTACT_FROM_UPDATE_PHONE_NUMBERS =
  'MESSENGER_REMOVE_CONTACT_FROM_UPDATE_PHONE_NUMBERS';
export const MESSENGER_RESET_CONTACTS_TO_UPDATE_PHONE_NUMBERS =
  'MESSENGER_RESET_CONTACTS_TO_UPDATE_PHONE_NUMBERS';
export const MESSENGER_CLEAR_CONTACTS_FOR_UPDATE_PHONE_NUMBERS =
  'MESSENGER_CLEAR_CONTACTS_FOR_UPDATE_PHONE_NUMBERS';
export const MESSENGER_SELECT_CONVERSATION_RECIPIENTS_WITH_PHONE_NUMBERS =
  'MESSENGER_SELECT_CONVERSATION_RECIPIENTS_WITH_PHONE_NUMBERS';
export const MESSENGER_SET_PERSON_DYNAMIC_COLOR = 'MESSENGER_SET_PERSON_DYNAMIC_COLOR';
export const MESSENGER_CONVERSATION_LIST_SET_FILTER = 'MESSENGER_CONVERSATION_LIST_SET_FILTER';
